/**
 * Veluna PDP offer - one plain, literally true discount offer on product pages.
 *
 * REBUILT 2026-09-23 (popup CRO pass). The previous version was a "mystery"
 * scratch card that said "a single discount, randomly assigned" while the
 * only prize configured was SLEEP10. It also auto-added the product to the
 * cart and redirected to checkout. All of that is gone:
 *   - no mystery / random framing, no scratch mechanic, no confetti
 *   - the offer is stated up front: 10% off a one-time order
 *   - the code is SHOWN, plainly, after the email is accepted (2xx only)
 *   - nothing is added to the cart and nobody is redirected anywhere
 *
 * SLEEP10 as configured in Shopify admin (checked 2026-09-23): 10% off
 * one-time purchase products, not subscriptions, one use per customer, does
 * not combine with other discounts. The legal line below says exactly that.
 * The code and percent still come from the pdp-mystery-popup section settings.
 *
 * Trigger: 15 s on the page or 40% scroll (2026-10-01, was 30 s / 50%), whichever
 * comes first, and only when VelunaCaptureGuard allows it (never over the buy box,
 * never after an add-to-cart this session, never after a capture). A close counts
 * for this page load only (2026-10-01, owner): no 7-day or session suppression.
 *
 * REDESIGNED 2026-10-01 (owner-approved mock, markup and CSS only): bone card
 * with a linen media panel showing the product's own picture (its __linen file
 * when it has one), a bottom sheet with a product thumbnail on phones, the
 * email step first and the code in a dashed box with a Copy button. Triggers,
 * suppression, measurement, the guard registration (pdp-mystery) and the POST
 * body are unchanged.
 *
 * TAKEOVER + FLIP (2026-10-01, owner): full-viewport layout (desktop: the
 * product's linen shot on a linen panel left 45%, bone content right; phones:
 * full-screen bone sheet with a 96x126 product thumbnail above the headline).
 * Step 1 is no longer the email field: three face-down cards, the visitor flips
 * one, it reveals the offer, then the email step follows. HONESTY RULE: every
 * card reveals the SAME real offer (the configured percent off this set) and no
 * copy claims chance, luck, winning or a prize. Steps are measured with gtag
 * veluna_popup_step {engine, surface, step: flip | email}. The exit-intent
 * subscription also asks for the Back-button trap (back: false).
 *
 * PHONE BAND + PAGE-ONLY DISMISSAL + EARLIER TRIGGERS (2026-10-01, owner, evening):
 *   - phones (max-width 640px): the sheet opens with a linen image band across the top
 *     (34vh, 220 to 300 px, the product shot centred at 85% of the band, the close X over
 *     the band); the content starts directly under it, top-aligned, scrolling on its own.
 *     The floating 96x126 thumbnail is gone. Desktop (two-panel takeover) is unchanged.
 *   - closing only silences THIS page load (shownOnce). No dismissal key is written, the
 *     legacy keys (veluna_pdp_offer_dismissed_until / _session) are ignored, the guard is
 *     not told. The captured rule, including the 30-day re-offer, is unchanged.
 *   - DWELL_MS 15 s (was 30), SCROLL_FRACTION 0.4 (was 0.5); 3 s exit minimum and
 *     PAST_BUYBOX unchanged.
 *
 * The file name and the section are unchanged so rollback is one asset.
 * The legacy checkout interceptor below is kept ONLY for visitors who already
 * hold a code from the old flow (veluna_pdp_mystery_won); new signups never
 * write that key.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('veluna-pdp-mystery-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (_) { return; }
  if (!CFG || !CFG.product) return;

  var OFFER = (CFG.prizes || []).filter(function (p) { return p && p.code && p.percent > 0; })[0] || null;

  var STORAGE = {
    legacyWon: 'veluna_pdp_mystery_won',
    offer: 'veluna_pdp_offer_code',
    dismissedUntil: 'veluna_pdp_offer_dismissed_until',
    sessionDismissed: 'veluna_pdp_offer_dismissed_session',
    captured: 'veluna_email_captured'
  };
  var DWELL_MS = 8000;           /* owner 2026-10-01 max leads: was 15000 */
  var SCROLL_FRACTION = 0.25;    /* owner 2026-10-01 max leads: was 0.4 */
  var CAPTURE_ID = 'pdp-mystery';

  try {
    if (/\/products\//.test(window.location.pathname)) {
      (window.__vlnPageSpecific = window.__vlnPageSpecific || []).push(CAPTURE_ID);
      window.VelunaCaptureGuard && window.VelunaCaptureGuard.registerPageSpecific(CAPTURE_ID);
    }
  } catch (e) {}

  var BACKEND = {
    url: 'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe',
    sequence: 'pdp_offer',
    popupVariant: 'pdp_offer_v2',
    source: 'veluna_pdp_offer'
  };

  /* Product handle -> concern code. Sets first, then the specific products.
     sleep-plus-collagen-cream must be tested before the generic collagen rule. */
  var CONCERN_NAMES = { mc: 'Mind Calm', dr: 'Deep Restore', ss: 'Sacred Soothe' };
  function concernFor(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('mind-calm') !== -1) return 'mc';
    if (h.indexOf('deep-restore') !== -1) return 'dr';
    if (h.indexOf('sacred-soothe') !== -1) return 'ss';
    if (/hyaluronic|sleep-plus|gummies/.test(h)) return 'ss';
    if (/recovery-cream|collagen/.test(h)) return 'dr';
    if (/sleep-formula|magnesium-glycinate|ashwagandha|sleep-strips/.test(h)) return 'mc';
    return '';
  }
  var CONCERN = concernFor(CFG.product.handle);

  function ls(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }

  var CAPTURE_RECENT_MS = 30 * 24 * 60 * 60 * 1000;
  function isCaptured() {
    var any = ls(STORAGE.captured) === 'true' || !!ls('veluna_pdf_captured') || !!ls(STORAGE.offer) ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((ls('veluna_quiz_email') || '').trim());
    if (!any) return false;
    /* 2026-10-01: a visitor whose capture is older than 30 days may be offered the code
       again (veluna_pdf_captured = '<email>|<ms>', veluna_pdp_offer_code carries ts).
       An unknown age counts as recent. The guard applies the same rule for this engine. */
    var ms = parseInt((ls('veluna_pdf_captured') || '').split('|')[1] || '0', 10) || 0, ts = 0;
    try { ts = (JSON.parse(ls(STORAGE.offer) || 'null') || {}).ts || 0; } catch (_) {}
    var newest = Math.max(ms, ts);
    return !(newest > 0 && Date.now() - newest > CAPTURE_RECENT_MS);
  }
  /* 2026-10-01 (owner): a close counts for this page load only (shownOnce). No dismissal key
     is written any more and the legacy ones (veluna_pdp_offer_dismissed_until / _session) are
     ignored, so visitors who closed an older version are not silenced for 7 days. */
  function isDismissed() { return false; }
  function hasLegacyWin() { return !!ls(STORAGE.legacyWon); }

  function fireLead(p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', source: p.source, concern: p.concern, surface: p.surface }); } catch (_) {}
  }
  function push(ev, extra) {
    try {
      if (!window.dataLayer) return;
      var o = { event: ev, product_handle: CFG.product.handle };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (_) {}
  }
  /* 2026-10-01: popup measurement shared with every capture engine (gtag only; the
     dataLayer pushes above stay). */
  function gaPopup(ev, p) { try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (_) {} }
  function triggerName(r) {
    r = String(r || '');
    if (r === 'scroll-depth') return 'scroll';
    if (r === 'exit-intent' || r === 'dwell' || r === 'scroll-up' || r === 'idle' || r === 'past-buybox') return r;
    return 'manual';
  }

  /* ---------- styles (this CSS lives in a JS string) ----------
     2026-10-01 redesign, the same card system as the guide popup. Families from the
     theme's variables (--veluna-serif / --veluna-ui / --veluna-mono) with literal
     fallbacks; !important because several theme stylesheets load asynchronously.
     Hooks kept: .vpm__overlay(.is-open), .vpm__card, .vpm__close, .vpm__frame[data-body],
     #vpm-email, .vpm__btn[data-submit], [data-code], [data-copy], [data-copied], data-skip, data-done. */
  function injectStyles() {
    if (document.getElementById('vpm-styles')) return;
    var SERIF = 'var(--veluna-serif,Newsreader,Georgia,serif)!important';
    var UI = 'var(--veluna-ui,"Hanken Grotesk",system-ui,sans-serif)!important';
    var MONO = 'var(--veluna-mono,"DM Mono",ui-monospace,monospace)!important';
    var O = '.vpm__overlay ';
    var css = [
      /* The dim + blur stays behind the panels for the fade in and out. */
      '.vpm__overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(27,27,27,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);display:flex;align-items:stretch;justify-content:stretch;padding:0;box-sizing:border-box;opacity:0;transition:opacity .25s ease;}',
      '.vpm__overlay.is-open{opacity:1;}',
      '.vpm__overlay *,.vpm__overlay *::before,.vpm__overlay *::after{box-sizing:border-box;}',
      /* Takeover (2026-10-01): two panels fill the viewport, linen media left (45%), bone content right. */
      '.vpm__card{position:relative;display:grid;grid-template-columns:45% minmax(0,1fr);grid-template-rows:minmax(0,1fr);width:100%;height:100%;max-width:none;max-height:none;overflow:hidden;background:#FBF9F5;color:#131313;border:0;border-radius:0;box-shadow:none;text-align:left;font-family:' + UI + ';transform:translateY(12px);transition:transform .3s ease;}',
      '.vpm__overlay.is-open .vpm__card{transform:none;}',
      O + '.vpm__card:focus{outline:none;}',
      '.vpm__media{display:flex;align-items:center;justify-content:center;min-width:0;min-height:0;padding:48px;background:#E9DDD1;}',
      '.vpm__media img{display:block;width:auto;height:auto;max-width:min(100%,480px);max-height:72vh;border-radius:8px;box-shadow:0 18px 44px rgba(0,0,0,.2);}',
      '.vpm__media--empty{display:none;}',
      '.vpm__card--nomedia{grid-template-columns:minmax(0,1fr);}',
      '.vpm__card--nomedia .vpm__frame{padding-left:max(32px,calc(50% - 300px));padding-right:max(32px,calc(50% - 300px));}',
      /* Content column: vertically centred while it fits, scrolls from the top when it does not. */
      '.vpm__frame{display:flex;flex-direction:column;min-width:0;min-height:0;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:72px clamp(32px,7vw,96px) 48px;background:#FBF9F5;text-align:left;}',
      '.vpm__frame::before,.vpm__frame::after{content:"";display:block;flex:1 0 0;min-height:0;}',
      '.vpm__frame>*{flex:0 0 auto;width:100%;max-width:560px;}',
      O + '.vpm__close{position:absolute;top:16px;right:16px;z-index:2;width:44px;height:44px;min-width:0;min-height:0;display:flex;align-items:center;justify-content:center;padding:0;margin:0;background:transparent;border:0;border-radius:50%;cursor:pointer;color:#6A6D78;line-height:0;}',
      O + '.vpm__close:hover{color:#131313;background:rgba(19,19,19,.06);}',
      '.vpm__head{display:flex;align-items:center;gap:14px;}',
      '.vpm__head-text{min-width:0;flex:1 1 auto;}',
      O + '.vpm__brand{margin:0 0 16px;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;color:#9A7B55;}',
      O + '.vpm__h{margin:0 0 14px;font-family:' + SERIF + ';font-weight:500!important;font-size:36px;line-height:1.12;letter-spacing:-.01em;color:#131313!important;text-wrap:balance;}',
      O + '.vpm__sub{margin:0 0 20px;max-width:none;font-family:' + UI + ';font-size:17px;line-height:1.5;color:#4a4d57;}',
      /* Step 1: three face-down cards, the same real offer behind each. */
      '.vpm__cards{display:flex;gap:16px;margin:4px 0 0;}',
      O + '.vpm__cardbtn{position:relative;flex:0 0 auto;width:144px;height:auto;min-width:0;min-height:0;margin:0;padding:0;background:transparent;border:0;border-radius:14px;box-shadow:none;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:transform .2s ease,opacity .3s ease;}',
      O + '.vpm__cardbtn:hover{transform:translateY(-4px);background:transparent;}',
      '.vpm__cardin{position:relative;display:block;width:100%;height:0;padding:133.333% 0 0;transform:perspective(900px) rotateY(0deg);transform-style:preserve-3d;transition:transform .5s ease;}',
      '.vpm__cardbtn.is-flipped .vpm__cardin{transform:perspective(900px) rotateY(180deg);}',
      '.vpm__cardface{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:10px;background:#FBF9F5;border:1px solid #ECE7DF;border-radius:14px;box-shadow:0 10px 24px rgba(20,20,20,.08);-webkit-backface-visibility:hidden;backface-visibility:hidden;}',
      O + '.vpm__cardbtn:hover .vpm__cardface{border-color:#D9CBB8;box-shadow:0 16px 32px rgba(20,20,20,.12);}',
      '.vpm__cardface--front{transform:rotateY(180deg);background:#fff;border-color:#C8A27B;}',
      '.vpm__moon{display:block;width:30px;height:30px;border-radius:50%;box-shadow:inset -9px 4px 0 0 #C8A27B;}',
      O + '.vpm__cardnum{display:block;margin:0;font-family:' + MONO + ';font-weight:500;font-size:13px;line-height:1;letter-spacing:.14em;color:#9A7B55;}',
      O + '.vpm__cardoffer{display:block;margin:0;font-family:' + SERIF + ';font-weight:500!important;font-size:24px;line-height:1.05;color:#131313!important;text-align:center;}',
      O + '.vpm__cardline{display:block;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.3;color:#4a4d57;text-align:center;}',
      '.vpm__cards.is-picked .vpm__cardbtn{cursor:default;}',
      '.vpm__cards.is-picked .vpm__cardbtn:not(.is-flipped){opacity:.4;pointer-events:none;}',
      O + '.vpm__cards.is-picked .vpm__cardbtn:hover{transform:none;}',
      '.vpm__form{display:flex;flex-direction:column;gap:0;text-align:left;margin:0;}',
      '.vpm__row{display:flex;gap:10px;}',
      '.vpm__label{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}',
      O + '.vpm__input{flex:1 1 auto;min-width:0;width:100%;height:50px;min-height:50px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#1b1b1b;font-family:' + UI + ';font-size:16px;line-height:normal;box-shadow:none;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__input::placeholder{color:#8A8D98;opacity:1;}',
      O + '.vpm__input:focus{outline:2px solid #C8A27B;outline-offset:1px;border-color:#C8A27B;}',
      O + '.vpm__btn{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:auto;height:50px;min-height:50px;margin:0;padding:0 22px;border:0;border-radius:12px;background:#C8A27B;color:#131313;font-family:' + UI + ';font-size:16px;font-weight:600;line-height:1;white-space:nowrap;cursor:pointer;text-decoration:none;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__btn:hover{background:#BE966D;color:#131313;}',
      O + '.vpm__btn[disabled]{opacity:.6;cursor:wait;}',
      O + '.vpm__error{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#A5522B;}',
      O + '.vpm__error:not(:empty){margin-top:8px;}',
      O + '.vpm__legal{margin:12px 0 0;font-family:' + UI + ';font-size:12.5px;line-height:1.5;color:#6A6D78;text-align:left;}',
      O + '.vpm__skip{display:inline-block;align-self:flex-start;width:auto;margin:22px 0 0;padding:0;background:transparent;border:0;cursor:pointer;font-family:' + UI + ';font-size:14px;line-height:1.4;color:#6A6D78;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vpm__skip:hover{color:#131313;}',
      '.vpm__code-row{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:6px 0 10px;}',
      O + '.vpm__code{display:inline-block;margin:0;padding:10px 16px;background:#fff;border:1px dashed #C8A27B;border-radius:10px;font-family:' + MONO + ';font-weight:500;font-size:26px;line-height:1;letter-spacing:.06em;color:#131313;user-select:all;-webkit-user-select:all;}',
      O + '.vpm__copy{height:44px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:10px;background:#fff;color:#131313;font-family:' + UI + ';font-size:14px;font-weight:600;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__copy:hover{border-color:#C8A27B;}',
      O + '.vpm__copied{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#4a4d57;}',
      O + '.vpm__copied:not(:empty){margin:0 0 10px;}',
      '.vpm__links{display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 0;}',
      O + '.vpm__link{display:inline-block;margin:0;padding:11px 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#131313;font-family:' + UI + ';font-size:15px;font-weight:600;line-height:1.2;text-decoration:none;}',
      O + '.vpm__link:hover{border-color:#C8A27B;color:#131313;}',
      O + '.vpm__close:focus-visible,' + O + '.vpm__btn:focus-visible,' + O + '.vpm__skip:focus-visible,' + O + '.vpm__copy:focus-visible,' + O + '.vpm__link:focus-visible{outline:2px solid #C8A27B;outline-offset:3px;}',
      O + '.vpm__cardbtn:focus-visible{outline:2px solid #C8A27B;outline-offset:4px;}',
      '@media (max-width:1024px){.vpm__card{grid-template-columns:42% minmax(0,1fr);}.vpm__card--nomedia{grid-template-columns:minmax(0,1fr);}.vpm__frame{padding:64px 32px 40px;}.vpm__media{padding:32px;}}',
      /* Phone (2026-10-01, owner): a full-screen bone sheet with a linen image band across the
         top (34vh, 220 to 300 px; the product shot centred at 85% of the band = clamp(187px,28.9vh,255px)),
         the close X over the band, the content directly under it, top-aligned (no centring
         spacers, no thumbnail), scrolling on its own while the band stays put. Three cards in a
         row, each a third of the width and 150 px tall. Step 2 and 3 controls are full width.
         A product with no picture keeps the band hidden and clears the X with top padding. */
      '@media (max-width:640px){' +
        '.vpm__card{display:flex;flex-direction:column;height:100%;}' +
        '.vpm__media{display:flex;flex:0 0 auto;align-items:center;justify-content:center;width:100%;height:34vh;min-height:220px;max-height:300px;padding:0 20px;background:#E9DDD1;}' +
        '.vpm__media--empty{display:none;}' +
        '.vpm__media img{width:auto;height:auto;max-width:100%;max-height:clamp(187px,28.9vh,255px);border-radius:6px;box-shadow:0 10px 24px rgba(0,0,0,.18);}' +
        '.vpm__frame{flex:1 1 auto;min-height:0;padding:20px 20px 28px;overflow-y:auto;}' +
        '.vpm__card--nomedia .vpm__frame{padding:68px 20px 28px;}' +
        '.vpm__frame::before,.vpm__frame::after{display:none;}' +
        '.vpm__frame>*{max-width:none;}' +
        O + '.vpm__close{top:12px;right:12px;}' +
        '.vpm__head{display:block;margin:0 0 10px;}' +
        O + '.vpm__brand{margin:0 0 8px;}' +
        O + '.vpm__h{margin:0;font-size:26px;}' +
        O + '.vpm__sub{margin:0 0 16px;font-size:15px;}' +
        '.vpm__cards{gap:10px;}' +
        O + '.vpm__cardbtn{flex:1 1 0;width:auto;max-width:none;}' +
        '.vpm__cardin{height:150px;padding:0;}' +
        O + '.vpm__cardoffer{font-size:20px;}' +
        O + '.vpm__cardline{font-size:12px;}' +
        '.vpm__row{flex-direction:column;gap:10px;}' +
        O + '.vpm__input{height:52px;min-height:52px;}' +
        O + '.vpm__btn{width:100%;height:52px;min-height:52px;}' +
        O + '.vpm__code{font-size:22px;}' +
        '.vpm__links{flex-direction:column;gap:10px;}' +
        O + '.vpm__link{display:block;width:100%;text-align:center;}' +
      '}',
      /* Reduced motion: no fade travel, no 3D flip (the faces swap), no hover lift. */
      '@media (prefers-reduced-motion:reduce){.vpm__overlay,.vpm__card,.vpm__cardin,' + O + '.vpm__cardbtn{transition:none;}.vpm__card{transform:none;}' + O + '.vpm__cardbtn:hover{transform:none;}}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'vpm-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- views ---------- */
  function legalLine() {
    return 'One use per customer. Works on a one-time set or the first delivery of a plan. ' +
      'Combines with free shipping only. No spam, unsubscribe anytime.';
  }
  /* 2026-10-01: the product's own picture for the media panel. Its __linen file when
     it has one (the featured image from the section config first, then this page's
     own gallery, matched on the product handle so a cross-sell card's linen shot is
     never picked), else the featured image, else the product JSON-LD image, else the
     first gallery image. CDN width is capped at 600 (the panel renders 244 px wide). */
  function cdnWidth(u, w) {
    u = String(u || '');
    if (!/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function productImage() {
    var handle = String(CFG.product.handle || '').toLowerCase();
    var feat = String(CFG.product.image || '');
    if (/__linen\./i.test(feat)) return cdnWidth(feat, 600);
    try {
      var imgs = document.querySelectorAll('img[src*="__linen"],img[srcset*="__linen"],img[data-src*="__linen"]');
      for (var i = 0; i < imgs.length; i++) {
        var src = imgs[i].currentSrc || imgs[i].getAttribute('src') || imgs[i].getAttribute('data-src') || '';
        if (src.indexOf('__linen') === -1) src = ((imgs[i].getAttribute('srcset') || '').split(',')[0] || '').trim().split(' ')[0];
        if (handle && src.toLowerCase().indexOf('/' + handle + '__linen') !== -1) return cdnWidth(src, 600);
      }
    } catch (_) {}
    if (feat) return cdnWidth(feat, 600);
    try {
      var lds = document.querySelectorAll('script[type="application/ld+json"]');
      for (var k = 0; k < lds.length; k++) {
        var d = JSON.parse(lds[k].textContent || 'null');
        var list = Array.isArray(d) ? d : (d && d['@graph']) ? d['@graph'] : [d];
        for (var m = 0; m < list.length; m++) {
          var o = list[m];
          if (o && o['@type'] === 'Product' && o.image) {
            var im = Array.isArray(o.image) ? o.image[0] : o.image;
            return String((im && im.url) || im || '');
          }
        }
      }
    } catch (_) {}
    var g = document.querySelector('.product__media img,.product-gallery img,[data-product-gallery] img,.pdp-gallery img,main img');
    return g ? (g.currentSrc || g.getAttribute('src') || '') : '';
  }
  var PRODUCT_IMAGE = null;
  function productImageUrl() { if (PRODUCT_IMAGE === null) PRODUCT_IMAGE = productImage() || ''; return PRODUCT_IMAGE; }
  /* "works until" date: the engine's value as given, or a readable date when it is
     an ISO timestamp (2026-10-08T23:59:00-04:00 -> Thursday, October 8). */
  function endsLabel(s) {
    s = String(s || '');
    if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
    var d = new Date(s);
    if (isNaN(d.getTime())) return s;
    try { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }); } catch (_) { return s; }
  }
  /* Eyebrow + headline. The picture is the media panel (desktop) or the band across the
     top (phones, 2026-10-01); no thumbnail. */
  function viewHead(eyebrow, h) {
    return '<div class="vpm__head">' +
      '<div class="vpm__head-text"><p class="vpm__brand">' + eyebrow + '</p>' +
      '<h2 class="vpm__h" id="vpm-title">' + h + '</h2></div></div>';
  }
  /* Step 1 (2026-10-01, owner): flip a card. HONESTY RULE, non-negotiable: every card
     holds the SAME real offer and no copy here may claim chance, luck, winning or a prize. */
  var STEP_ADVANCE_MS = 700;
  function cardWords() { return { offer: esc(OFFER.percent) + '% off', line1: 'this set' }; }
  function viewFlip() {
    var cw = cardWords(), cards = '';
    for (var i = 1; i <= 3; i++) {
      cards += '<button class="vpm__cardbtn" type="button" data-flip="' + i + '" aria-label="Card ' + i + ': flip to reveal your offer on this set">' +
        '<span class="vpm__cardin">' +
        '<span class="vpm__cardface vpm__cardface--back"><span class="vpm__moon" aria-hidden="true"></span><span class="vpm__cardnum">' + i + '</span></span>' +
        '<span class="vpm__cardface vpm__cardface--front" aria-hidden="true"><span class="vpm__cardoffer">' + cw.offer + '</span><span class="vpm__cardline">' + cw.line1 + '</span></span>' +
        '</span></button>';
    }
    return '' +
      viewHead('First set', 'Flip a card to reveal your offer on this set.') +
      '<p class="vpm__sub">Pick one.</p>' +
      '<div class="vpm__cards" data-cards role="group" aria-label="Three cards, pick one">' + cards + '</div>' +
      '<button class="vpm__skip" type="button" data-skip>No thanks</button>';
  }
  function stepEvent(step) { gaPopup('veluna_popup_step', { engine: 'pdp_offer', surface: 'pdp', step: step }); }
  function onFlip(btn) {
    var wrap = overlay && overlay.querySelector('[data-cards]');
    if (!wrap || wrap.classList.contains('is-picked') || btn.disabled) return;
    var cw = cardWords();
    wrap.classList.add('is-picked');
    btn.classList.add('is-flipped');
    btn.setAttribute('aria-label', cw.offer + ' ' + cw.line1);
    [].slice.call(wrap.querySelectorAll('[data-flip]')).forEach(function (b) { if (b !== btn) b.disabled = true; });
    stepEvent('flip');
    setTimeout(function () { if (isOpen && overlay && overlay.querySelector('[data-cards]')) showEmailStep(); }, STEP_ADVANCE_MS);
  }
  function showEmailStep() {
    render(viewOffer());
    stepEvent('email');
    setTimeout(function () { var f = overlay && overlay.querySelector('#vpm-email'); if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} } }, 40);
  }
  /* Step 2: the email, with the small print. */
  function viewOffer() {
    return '' +
      viewHead('First set', 'Claim your ' + esc(OFFER.percent) + '% off') +
      '<p class="vpm__sub">Enter your email and your code appears right here.</p>' +
      '<form class="vpm__form" data-form novalidate>' +
        '<label class="vpm__label" for="vpm-email">Email address</label>' +
        '<div class="vpm__row">' +
        '<input class="vpm__input" id="vpm-email" type="email" name="email" placeholder="you@example.com" required autocomplete="email" />' +
        '<button class="vpm__btn" type="submit" data-submit>Claim my offer</button>' +
        '</div>' +
        '<p class="vpm__error" data-error role="status" aria-live="polite"></p>' +
      '</form>' +
      '<p class="vpm__legal">' + esc(legalLine()) + '</p>' +
      '<button class="vpm__skip" type="button" data-skip>No thanks</button>';
  }
  var MINE = null; /* 2026-10-01: the signup's own code from the engine */
  function codeNow() { return (MINE && MINE.signup_code) || OFFER.code; }
  function viewCode() {
    return '' +
      viewHead('Your code, ready now', 'Here is your ' + esc(OFFER.percent) + '% off') +
      '<div class="vpm__code-row"><span class="vpm__code" data-code>' + esc(codeNow()) + '</span>' +
      '<button class="vpm__copy" type="button" data-copy>Copy</button></div>' +
      '<p class="vpm__copied" data-copied role="status" aria-live="polite"></p>' +
      '<p class="vpm__sub">' + (MINE && MINE.signup_code ? 'Your own code, works until ' + esc(endsLabel(MINE.signup_ends || '')) + '. ' : '') +
      'Enter it at checkout, on a one-time set or the first delivery of a plan.</p>' +
      '<div class="vpm__links"><a class="vpm__link" href="/pages/ritual-essentials" data-sets-link>See the sets</a></div>' +
      '<p class="vpm__legal">' + esc(legalLine().replace(' No spam, unsubscribe anytime.', '')) + '</p>' +
      '<button class="vpm__skip" type="button" data-done>Back to the product</button>';
  }

  /* ---------- build / open / close ---------- */
  var overlay = null, isOpen = false, releaseFocus = null, shownOnce = false;

  function render(html) { overlay.querySelector('[data-body]').innerHTML = html; }

  function build() {
    if (overlay) return overlay;
    injectStyles();
    overlay = document.createElement('div');
    overlay.className = 'vpm__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vpm-title');
    overlay.setAttribute('data-capture-id', CAPTURE_ID);
    var img = productImageUrl();
    /* The close X sits last in the DOM (it is positioned top-right anyway) so the first Tab
       from the dialog lands on card 1. The card container takes the initial focus
       (tabindex -1, no ring) so no card looks pre-selected on open. */
    overlay.innerHTML = '<div class="vpm__card' + (img ? '' : ' vpm__card--nomedia') + '" tabindex="-1">' +
      '<div class="vpm__media' + (img ? '' : ' vpm__media--empty') + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(CFG.product.title) + '" width="300" height="300" decoding="async" />' : '') + '</div>' +
      '<div class="vpm__frame" data-body></div>' +
      '<button class="vpm__close" type="button" data-close aria-label="Close">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button></div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { close('backdrop'); return; }
      if (e.target.closest('[data-close]')) { close('close-btn'); return; }
      if (e.target.closest('[data-skip]')) { close('skip'); return; }
      if (e.target.closest('[data-done]')) { close('done'); return; }
      var flip = e.target.closest('[data-flip]');
      if (flip) { onFlip(flip); return; }
      if (e.target.closest('[data-copy]')) { copyCode(); }
    });
    overlay.addEventListener('submit', function (e) {
      if (e.target.matches('[data-form]')) { e.preventDefault(); onEmailSubmit(e.target); }
    });
    document.addEventListener('keydown', function (e) {
      if (isOpen && (e.key === 'Escape' || e.key === 'Esc')) close('esc');
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function open(reason, kind) {
    if (!shouldShow()) return;
    build();
    render(viewFlip());
    isOpen = true;
    shownOnce = true;
    popCount('pdp');
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen(CAPTURE_ID); } catch (_) {}
    requestAnimationFrame(function () { if (overlay) overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    try {
      var G = window.VelunaCaptureGuard;
      releaseFocus = G && G.holdFocus ? G.holdFocus(overlay, { focus: false }) : null;
    } catch (_) { releaseFocus = null; }
    setTimeout(function () {
      var f = overlay && overlay.querySelector('.vpm__card');
      if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} }
    }, 60);
    /* 2026-10-01: exit_kind names the exit signal; trigger stays 'exit-intent'. */
    var shown = { trigger: reason, offer_percent: OFFER.percent };
    var ga = { engine: 'pdp_offer', surface: 'pdp', trigger: triggerName(reason) };
    if (kind) { shown.exit_kind = kind; ga.exit_kind = kind; }
    push('veluna_pdp_offer_shown', shown);
    gaPopup('veluna_popup_shown', ga);
  }

  function close(reason) {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed(CAPTURE_ID); } catch (_) {}
    /* 2026-10-01 (owner): the close counts for this page load only (shownOnce). No dismissal
       key, no guard dismissal (notifyDismissed); the next page load asks again unless
       captured. The dismissed event still fires. */
    if (!isCaptured()) gaPopup('veluna_popup_dismissed', { engine: 'pdp_offer', surface: 'pdp' });
    if (releaseFocus) { try { releaseFocus(); } catch (_) {} releaseFocus = null; }
    var el = overlay;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); if (overlay === el) overlay = null; }, 260);
    push('veluna_pdp_offer_closed', { reason: reason });
  }

  function copyCode() {
    var note = overlay && overlay.querySelector('[data-copied]');
    function ok() { if (note) note.textContent = 'Copied. Paste it into the discount box at checkout.'; }
    function fail() { if (note) note.textContent = 'Select the code above to copy it.'; }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(codeNow()).then(ok, fail); return; }
    } catch (_) {}
    fail();
  }

  function onEmailSubmit(form) {
    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('[data-submit]');
    var email = (input.value || '').trim();
    errEl.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errEl.textContent = 'Please enter a full email address.'; input.focus(); return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    submitToBackend(email).then(function (res) {
      if (!res || !res.ok) throw new Error('subscribe_failed');
      return res.json().catch(function () { return {}; });
    }).then(function (j) {
      if (j && j.signup_code) MINE = j;
      lsSet(STORAGE.captured, 'true');
      lsSet('veluna_pdf_captured', email + '|' + Date.now());
      lsSet(STORAGE.offer, JSON.stringify({ code: codeNow(), percent: OFFER.percent, ts: Date.now(), product: CFG.product.handle }));
      fireLead({ source: BACKEND.source, concern: CONCERN, surface: 'pdp' });
      push('veluna_lead_captured', { source: BACKEND.source, concern: CONCERN, offer_percent: OFFER.percent });
      render(viewCode());
      setTimeout(function () { var b = overlay && overlay.querySelector('[data-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (_) {} } }, 40);
    }).catch(function () {
      errEl.textContent = 'That did not go through. Please try again.';
      btn.disabled = false; btn.textContent = 'Claim my offer';
    });
  }

  function submitToBackend(email) {
    var tags = [BACKEND.source, 'pdp_' + (CFG.product.handle || 'unknown'), BACKEND.sequence];
    if (CONCERN) tags.push('concern_' + CONCERN);
    var body = {
      email: email,
      topic: 'popup_subscribe',
      want_code: true,
      first_name: '',
      source: BACKEND.source,
      email_sequence: BACKEND.sequence,
      popup_variant: BACKEND.popupVariant,
      tags: tags,
      fields: {
        sleep_concern: CONCERN,
        ritual_type: CONCERN ? CONCERN_NAMES[CONCERN] : '',
        email_sequence: BACKEND.sequence,
        popup_variant: BACKEND.popupVariant,
        discount_code: OFFER.code,
        discount_percent: OFFER.percent,
        product_handle: CFG.product.handle,
        product_title: CFG.product.title,
        product_url: CFG.product.url
      },
      metadata: { page: window.location.pathname, referrer: document.referrer || '',
                  user_agent: (navigator && navigator.userAgent) || '' }
    };
    /* Top-level concern routes the welcome email. Omitted when the product
       maps to none, so the engine applies its own default. */
    if (CONCERN) body.concern = CONCERN;
    return fetch(BACKEND.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { return null; });
  }

  /* ---------- triggers ---------- */
  var PREVIEW = /[?&]popup_preview=1\b/.test(window.location.search);
  /* An exit (pointer leaving the window) may open while the buy box is on
     screen; every other guard rule still applies. 2026-09-29. */
  var EXITING = false;
  /* 2026-10-01 (owner: no popups ever appeared on phone product pages): on phones the buy box fills the
     first screens, so once the visitor has scrolled PAST the main add-to-cart button (its bottom is above
     the viewport) the commerce rule no longer blocks this offer; cross-sell buttons further down do not count. */
  var PAST_BUYBOX = false;
  function mainAtc() { return document.getElementById('recovery-cream-add-to-cart') || document.querySelector('form[action*="/cart/add"] [data-veluna-atc], [data-veluna-atc]'); }
  function pastBuyBox() { var a = mainAtc(); if (!a) return false; var r = a.getBoundingClientRect(); return r.bottom < 0; }
  function guardAllows(id) {
    var G = window.VelunaCaptureGuard;
    if (!G) return true;
    var r = G.reason ? G.reason(id) : (G.mayShow(id) ? null : 'blocked');
    return r === null || ((EXITING || PAST_BUYBOX) && r === 'commerce_configuration_visible');
  }
  /* 2026-10-01: exit intent comes from the shared detector in veluna-capture-guard.js
     (window.VelunaExitIntent). If that file has not run yet the subscription waits in
     window.__vlnExitQueue and the helper picks it up. */
  function onExitIntent(fn, opts) {
    if (window.VelunaExitIntent && window.VelunaExitIntent.listen) { window.VelunaExitIntent.listen(fn, opts); return; }
    (window.__vlnExitQueue = window.__vlnExitQueue || []).push([fn, opts]);
  }
  /* 2026-10-01 (owner): at most 2 showings per visit per popup type. */
  function popShows(t) { try { return +(sessionStorage.getItem('veluna_pop_shows_' + t) || 0); } catch (_) { return 0; } }
  function popCount(t) { try { sessionStorage.setItem('veluna_pop_shows_' + t, String(popShows(t) + 1)); } catch (_) {} }
  function shouldShow() {
    if (isOpen || !OFFER) return false;
    if (PREVIEW) return true;
    if (shownOnce) return false;
    if (popShows('pdp') >= 2) return false;   /* owner 2026-10-01: max 2 per visit */
    if (hasLegacyWin() || isCaptured() || isDismissed()) return false;
    if (!guardAllows(CAPTURE_ID)) return false;
    return true;
  }

  function installTriggers() {
    var loadedAt = Date.now(), armed = false, poll = null;
    function scrolledHalf() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      return max > 0 && (window.scrollY || doc.scrollTop || 0) / max >= SCROLL_FRACTION;
    }
    function attempt(reason) {
      if (!armed) {
        if (Date.now() - loadedAt >= DWELL_MS) armed = 'dwell';
        else if (scrolledHalf()) armed = 'scroll-depth';
        else return;
      }
      if (shownOnce || isDismissed() || isCaptured()) { stop(); return; }
      if (reason === 'past-buybox' && !pastBuyBox()) return;   /* scrolled back up onto the buy box: wait */
      if (shouldShow()) { stop(); open(reason || armed); }
    }
    var COARSE = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    var pastTimer = null;
    function onScroll() {
      if (COARSE && !PAST_BUYBOX && pastBuyBox()) {
        PAST_BUYBOX = true;
        if (!armed) armed = 'past-buybox';
        clearTimeout(pastTimer);
        pastTimer = setTimeout(function () { attempt('past-buybox'); }, Math.max(1200, 3000 - (Date.now() - loadedAt)));
        return;
      }
      attempt();
    }
    function stop() {
      window.removeEventListener('scroll', onScroll);
      if (poll) { clearInterval(poll); poll = null; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Exit intent (2026-10-01) after 3 s on the page (was 5 s, top edge only). Desktop:
       top, predict, side (after 6 s), keyboard, tab-return. Phones: scroll-up (120 px
       back up after 30% depth), idle (8 s still after 30% depth), tab-return. Same
       shouldShow()/guard path as dwell and scroll: an add-to-cart, a dismissal or a
       capture still refuse every kind. Only the exit kinds may open while the buy box
       is on screen (EXITING); scroll-up and idle wait like dwell and scroll do. */
    /* back: false (2026-10-01, owner): the helper pushes one history entry; the first Back
       press arrives here as kind 'back' (trigger exit-intent, exit_kind back) and the next
       Back leaves. Returning true tells the helper the offer opened; on false the helper
       leaves the page itself so the press is never swallowed. */
    onExitIntent(function (kind) {
      if (shownOnce || isDismissed() || isCaptured()) return false;
      var exit = kind !== 'scroll-up' && kind !== 'idle';
      EXITING = exit;
      try { if (shouldShow()) { stop(); open(exit ? 'exit-intent' : kind, kind); return isOpen; } } finally { EXITING = false; }
      return false;
    }, { minMs: 3000, minSideMs: 6000, back: false });
    /* Once the dwell (15 s) has passed, keep checking gently: the guard refuses while
       the buy box is on screen, so the offer waits for the visitor to move on. */
    setTimeout(function () { attempt('dwell'); if (!shownOnce && !poll) poll = setInterval(function () { attempt(); }, 2000); }, DWELL_MS);
  }

  /* ---------- legacy holders of an old scratch-card code ---------- */
  function getLegacyPrize() {
    try { var d = JSON.parse(ls(STORAGE.legacyWon) || 'null'); return (d && d.code) ? d : null; } catch (_) { return null; }
  }
  function installLegacyCheckoutInterceptor() {
    if (window.__velunaCheckoutInterceptorInstalled) return;
    window.__velunaCheckoutInterceptorInstalled = true;
    document.addEventListener('click', function (e) {
      var prize = getLegacyPrize();
      if (!prize) return;
      var t = e.target && e.target.closest && e.target.closest('a[href*="/checkout"], a[href*="/cart/checkout"], button[name="checkout"], [data-checkout-button], [data-action="checkout"]');
      if (!t || t.getAttribute('data-veluna-discount-applied') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      t.setAttribute('data-veluna-discount-applied', '1');
      var target = (t.tagName === 'A' && t.getAttribute('href')) ? t.getAttribute('href') : '/checkout';
      window.location.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(target);
    }, true);
  }

  /* 2026-09-30: a known subscriber viewing a product page tells the email engine (topic
     browse_abandon), at most once per product per 24 h. The email comes from any Veluna form on
     this device (veluna_pdf_captured = "<email>|<ms>"). The engine ignores unknown addresses and
     cancels the reminder if they buy. */
  function sendBrowse() {
    try {
      if (PREVIEW) return;
      var raw = localStorage.getItem('veluna_pdf_captured') || '';
      var email = raw.split('|')[0].trim().toLowerCase();
      var handle = CFG.product && CFG.product.handle;
      if (!handle || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      var key = 'veluna_browse_sent_' + handle, last = parseInt(localStorage.getItem(key) || '0', 10);
      if (last && Date.now() - last < 24 * 60 * 60 * 1000) return;
      localStorage.setItem(key, String(Date.now()));
      var t = document.querySelector('meta[property="og:title"]');
      fetch(BACKEND.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ topic: 'browse_abandon', email: email, product_handle: handle,
          product_name: (t && t.getAttribute('content')) || document.title || '' }) }).catch(function () {});
    } catch (_) {}
  }

  function init() {
    sendBrowse();
    if (hasLegacyWin()) { installLegacyCheckoutInterceptor(); return; }
    if (!OFFER) return;
    /* 2026-10-01: this engine no longer asks the guard to remember a dismissal; clear the key
       an earlier version may have left in this tab so VelunaCaptureGuard.reason() does not block. */
    try { sessionStorage.removeItem('veluna_capture_dismissed_session:' + CAPTURE_ID); } catch (_) {}
    if (PREVIEW) { setTimeout(function () { open('preview'); }, 800); return; }
    if (isCaptured() || isDismissed()) return;
    installTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* QA helper: opens the offer regardless of storage (does not submit anything). */
  window.__velunaMysteryTest = function () {
    try {
      localStorage.removeItem(STORAGE.dismissedUntil); sessionStorage.removeItem(STORAGE.sessionDismissed);
    } catch (_) {}
    shownOnce = false;
    if (!isOpen && OFFER) { var saved = PREVIEW; PREVIEW = true; open('manual-test'); PREVIEW = saved; }
  };
})();
